/* eslint-disable react/jsx-props-no-spreading */
import React, { RefObject } from 'react';
import { useSliderThumb } from '@react-aria/slider';
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';

interface ThumbProps {
    index: number;
    state: import('@react-stately/slider').SliderState;
    trackRef: RefObject<HTMLDivElement>;
}

export const Thumb = ({ index, state, trackRef }: ThumbProps): JSX.Element => {
    const inputRef = React.useRef(null);
    const { thumbProps, inputProps } = useSliderThumb(
        {
            index,
            trackRef,
            inputRef,
        },
        state,
    );

    const { focusProps, isFocusVisible } = useFocusRing();

    const bgColor = isFocusVisible ? 'highlight-palelavender' : 'white';

    return (
        <div
            style={{
                position: 'absolute',
                top: 4,
                transform: 'translateX(-50%)',
                left: `${state.getThumbPercent(index) * 100}%`,
            }}
        >
            <div
                {...thumbProps}
                style={{
                    height: 25,
                    width: 25,
                    boxShadow: '0 4px 8px 0px #757575',
                }}
                className={`bg-${bgColor} rounded-full shadow-inner`}
            >
                <input
                    className="visually-hidden"
                    ref={inputRef}
                    {...mergeProps(inputProps, focusProps)}
                />
            </div>
        </div>
    );
};
